import "./style.scss";

import { Radio } from "@mui/material";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/store";

/**
 * This component render a sheet row (google sheets inside a spreadsheet)
 */
interface ISheetRow {
    sheetTitle: string;
    sheetId: number;
    /**
     * Sheet index
     */
    index: number;
    onSelectSheet: (sheetTitle: string, sheetId: number) => void;
}

const SheetRow = ({ sheetTitle, index, onSelectSheet, sheetId }: ISheetRow) => {
    const [t] = useTranslation();
    const selectedSheet = useAppSelector((state) => state.partnerStatements.selectedSheet);
    const isSelected = sheetId === selectedSheet.id;

    return (
        <div className="google-sheet-row" onClick={() => onSelectSheet(sheetTitle, sheetId)}>
            <div className="google-sheet-row-left">
                <Radio checkedIcon={<GridCheckCircleIcon />} checked={isSelected} className="sheet-radio" />
                <span className={`google-sheet-title ${isSelected ? "sheet-selected" : ""}`}>{sheetTitle}</span>
            </div>
            <div className="google-sheet-row-right">
                <span className={isSelected ? "sheet-selected" : ""}>
                    {index == 0 ? t("PartnerStatements.MainSheet") : `${t("PartnerStatements.Sheet")} ${index + 1}`}
                </span>
            </div>
        </div>
    );
};

export default SheetRow;
